/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/ParseEndOfLineSequence.ts
 * @create:      2025-07-01 18:00:06.401
 * @modify:      2025-07-11 21:19:12.944
 * @version:     6.0.0
 * @times:       4
 * @lines:       50
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_CR_LF, Strings_LF } from "../const/Strings";

/**
 * Determines the end-of-line (EOL) sequence used in the provided string.
 *
 * Checks if the input string contains a carriage return and line feed sequence (`Strings_CR_LF`).
 * If found, returns `Strings_CR_LF`; otherwise, returns `Strings_LF`.
 *
 * @param data - The string to inspect for EOL sequences.
 * @returns The detected EOL sequence, either `Strings_CR_LF` or `Strings_LF`.
 * 
 * @since 5.0.0
 * @version 2025-06-18
 */
export function ParseEndOfLineSequence(data: string) {
    return data.includes(Strings_CR_LF) ? Strings_CR_LF : Strings_LF;
}
